import React from 'react';

function Assumptions() {
  return (
    <div className="assumptions">
      <h3>Key Assumptions & Tax Calculations</h3>
      <ul>
        <li><strong>Initial Investment:</strong> $200,000 starting July 18, 2025 (Week 29)</li>
        <li><strong>Base Salary:</strong> $0 annually</li>
        <li><strong>Federal Tax Rate:</strong> 24% (based on income bracket)</li>
        <li><strong>NY State + NYC Tax:</strong> 9.65% combined</li>
        <li><strong>Net Investment Income Tax (NIIT):</strong> 3.8% when total income exceeds $200,000</li>
        <li><strong>Tax Treatment:</strong> Taxes applied to all years (2025-2029). All gains treated as short-term capital gains.</li>
        <li><strong>Profit Sharing:</strong> 60/40 split after taxes. Your 60% share (green/weekly, purple/month-end) and 40% reinvestment share (orange/weekly, dark purple/month-end) are shown on every row.</li>
        <li><strong>Growth Strategy:</strong> Compound weekly returns targeting required growth rate to reach $2M</li>
        <li><strong>Target Achievement:</strong> $2,000,000+ net value by December 28, 2029</li>
        <li><strong>Interactive Features:</strong> Change the initial investment amount above to see how it affects your entire investment journey in real-time!</li>
      </ul>
    </div>
  );
}

export default Assumptions;
